<template>
  <div id="app" @mousemove="moveEvent" @click="moveEvent">

    <NavHeader
               v-if="showTitle && router!='orderInfo' && router!='reportIndex'&&router!='Inventory' &&router!='Activity'&&router!='Personal'&&router!='Prout'&&router!='Visit'&&router!='Sales'&&router!='OrderQuery'&&router!='Salesman'&&router!='Logistics'"
               :status="showTitle"/>
    <div :class="$style.main" id="main"
         v-if="router!='orderInfo' && router!='reportIndex'&&router!='Inventory' &&router!='Activity'&&router!='Personal'&&router!='Prout'&&router!='Visit'&&router!='Sales'&&router!='OrderQuery'&&router!='Salesman'&&router!='Logistics'"
         :style="{display:'flex',flexDirection: 'column',paddingLeft:showTitle?'50px':'0',paddingRight:showTitle?'50px':'0',marginTop:showTitle?'15px':'0',height:showTitle?'calc(100vh - 95px)':'100%'}" >

      <!--<router-view/>-->
      <transition :key="key" >
        <router-view class="router-view"></router-view>
      </transition>
    </div>

    <div v-if="router=='orderInfo' || router=='reportIndex'||router=='Inventory'||router=='Activity'||router=='Personal'||router=='Prout'||router=='Visit'||router=='Sales'||router=='OrderQuery'||router=='Salesman'||router=='Logistics'" style="overflow: scroll">

      <router-view />
    </div>

  </div>
</template>

<script>
import NavHeader from './components/navHeader'
export default {
  name: 'App',
    data () {
    return {
      showTitle: true,
      router:"",
      timmer: null,
    }
  },
  computed: {
      key() {
          return this.$route.name !== undefined? this.$route.name + +new Date(): this.$route + +new Date()
      }
  },
  methods:{
    moveEvent(){
      let path = ['/login']
      if(!path.includes(this.$route.path)) { //如果不是登录页面的话页面停止进行30分钟后清空session
        clearTimeout(this.timmer);
        this.init();
      }
    },
    init(){
      this.timmer=setTimeout(()=>{
        debugger
        //清除session
        sessionStorage.removeItem("MainCustomer");
        sessionStorage.clear();

        this.GLOBAL.territory_id = "";
        this.GLOBAL.date = "";
        this.showTitle = false
        this.router=""
        this.timmer = null
        //跳往登录页面
        this.$router.push({
          path: "/login",
        });

      },30*60*1000);//设置半小时清空session进入屏保
    },
  },
  // created () {
  //   //在页面加载时读取sessionStorage里的状态信息
  //   if (sessionStorage.getItem("store") ) {
  //     this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
  //
  //   }
  //
  //   //在页面刷新时将vuex里的信息保存到sessionStorage里
  //   window.addEventListener("beforeunload",()=>{
  //     console.log(this.$store.state,22)
  //     // sessionStorage.setItem("store",JSON.stringify(this.$store.state))
  //   })
  // },
  components: {
    NavHeader
  },
  watch: {
    $route: {
      handler (to, from) {

        let pathIndex = to.fullPath.split("?")[0]

        if (to.fullPath === '/login') {
          this.showTitle = false
          this.router=""
        } else if (pathIndex === '/orderInfo') {
          this.router = "orderInfo"
        } else if (to.fullPath === '/reportIndex') {
          this.router = "reportIndex"
        }else if (to.fullPath === '/Inventory') {
          this.router = "Inventory"
        }else if (to.fullPath === '/Activity') {
          this.router = "Activity"
        }else if (to.fullPath === '/Personal') {
          this.router = "Personal"
        }else if (to.path === '/Prout') {
          this.router = "Prout"
        }else if (to.fullPath === '/Visit') {
          this.router = "Visit"
        }else if (to.fullPath === '/Sales') {
          this.router = "Sales"
        }else if (to.fullPath === '/OrderQuery') {
          this.router = "OrderQuery"
        }else if (to.fullPath === '/Salesman') {
          this.router = "Salesman"
        }else if (to.fullPath === '/Logistics') {
          this.router = "Logistics"
        }
        else {
          this.showTitle = true
        }
      },
      immediate: true
    }
  }
}
</script>

<style>
#app {

  font-family:"Helvetica Neue","Helvetica","PingFang SC","Hiragino Sans GB","Microsoft YaHei",SimSun,sans-serif;
  background: #e7e8eb;
  height: 100vh;
  overflow: hidden;
}
#app .el-table th.gutter{
  display: table-cell!important;
}

#app .el-table colgroup.gutter{
  display: table-cell!important;
}
</style>

<style lang="scss" module>
  .main {
    position: relative;
    margin-top: 20px;
    padding: 0px 50px;
    box-sizing: border-box;
    height: calc(100vh - 80px);
    overflow: auto;
    width: 100%;
    background: #e7e8eb;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue